var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnrollmentBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 11.5C30 13 29 13 29 13V25C29.5 25 30 25.5 30 26C30 26.5 29.5 27 29 27L20.8316 27.0248C20.7763 27.0246 20.7232 27.047 20.6841 27.0869C20.6449 27.1269 20.6231 27.1811 20.6233 27.2377V27.5049C20.6245 27.573 20.6577 27.6364 20.7125 27.6752C21.1608 27.994 21.3546 28.5731 21.191 29.1054C21.0275 29.6378 20.5445 30 19.9982 30C19.4519 30 18.9688 29.6378 18.8053 29.1054C18.6417 28.5731 18.8355 27.994 19.2839 27.6752C19.3386 27.6364 19.3718 27.573 19.373 27.5049V27.2377C19.3733 27.1811 19.3514 27.1269 19.3123 27.0869C19.2731 27.047 19.22 27.0246 19.1647 27.0248L11 27C10.5 27 10 26.5 10 26C10 25.5 10.5 25 11 25V13C11 13 10 13 10 11.5C10 10 11 10 11 10H29C29 10 30 10 30 11.5ZM13.5 24H26.5C26.5 24 27 24 27 23.5C27 23 26.5 23 26.5 23H25V14.5C25 14 24.5 14 24.5 14H23.5C23.5 14 23 14 23 14.5V23H21V16.5C21 16.5 21 16 20.5 16H19.5C19.5 16 19 16 19 16.5V23H17V19.5C17 19 16.5 19 16.5 19L15.5 18.9767C15.5 19 15 19 15 19.5V23H13.5C13.5 23 13 23 13 23.5C13 24 13.5 24 13.5 24Z",
    fill: "#4CD2CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollmentBadge);
export default __webpack_public_path__ + "static/media/enrollment-badge.355c9b28.svg";
export { ForwardRef as ReactComponent };